<template>
  <AppAlert type="success">
    <div v-if="method == 'email'" v-html="$tt('email_images_continue', { email })" />
    <div
      v-else-if="method == 'whatsapp'"
      v-html="$tt('whatsapp_images_continue', { url: whatsappLink, phone: whatsapp.display })"
    />
    <div v-else-if="method == 'later'" v-html="$tt('continue_img_upload_later')" />
  </AppAlert>
</template>

<script setup lang="ts">
import type { FileTransferMethod } from '~/types';

defineProps<{
  method: FileTransferMethod;
}>();

const { whatsapp, whatsappLink } = useCommunication();
const { photosEmailAddress: email } = useRouting();
</script>